// ---------- WhatsApp ----------

const WHATSAPP_URL_BASE = "https://api.whatsapp.com/send/";

const BR_LOCAL_PHONE_LENGTH = 11;
const BR_COUNTRY_CODE = "55";

export function parsePhoneFromWhatsappUrl(
  url: string | null | undefined,
): string | null {
  if (!url) return null;
  try {
    const phone = new URL(url).searchParams.get("phone");
    const digits = phone?.replace(/\D/g, "") ?? "";
    return digits.length > 0 ? digits : null;
  } catch {
    return null;
  }
}

export function phoneToWhatsappUrl(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  return `${WHATSAPP_URL_BASE}?phone=${digits}&text&type=phone_number&app_absent=0`;
}

// Aceita o que o usuário digitou/colou e devolve só dígitos.
// Se reconhecer uma URL do WhatsApp, extrai o número da query.
export function normalizeWhatsappInput(value: string): string {
  if (!value) return "";
  if (/^https?:\/\//i.test(value.trim())) {
    return parsePhoneFromWhatsappUrl(value.trim()) ?? "";
  }
  return value.replace(/\D/g, "");
}

// Quando o número tem 11 dígitos (DDD + 9 dígitos) prepende 55 (BR);
// caso contrário deixa como está (assume que o usuário já incluiu o DDI).
export function ensureBrCountryCode(digits: string): string {
  return digits.length === BR_LOCAL_PHONE_LENGTH
    ? `${BR_COUNTRY_CODE}${digits}`
    : digits;
}

// ---------- Instagram ----------

const INSTAGRAM_URL_BASE = "https://www.instagram.com/";

export function parseInstagramUsername(
  url: string | null | undefined,
): string | null {
  return parseUsernameFromUrl(url, /(^|\.)instagram\.com$/i);
}

export function usernameToInstagramUrl(username: string): string {
  return `${INSTAGRAM_URL_BASE}${username}`;
}

export function normalizeInstagramInput(value: string): string {
  return normalizeSocialInput(value, parseInstagramUsername);
}

// ---------- Facebook ----------

const FACEBOOK_URL_BASE = "https://www.facebook.com/";

export function parseFacebookUsername(
  url: string | null | undefined,
): string | null {
  return parseUsernameFromUrl(url, /(^|\.)(facebook\.com|fb\.com)$/i);
}

export function usernameToFacebookUrl(username: string): string {
  return `${FACEBOOK_URL_BASE}${username}`;
}

export function normalizeFacebookInput(value: string): string {
  return normalizeSocialInput(value, parseFacebookUsername);
}

// ---------- Genéricos (Instagram / Facebook) ----------

function parseUsernameFromUrl(
  url: string | null | undefined,
  hostnamePattern: RegExp,
): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (!hostnamePattern.test(u.hostname)) return null;
    const segment = u.pathname.split("/").filter(Boolean)[0];
    return segment ?? null;
  } catch {
    return null;
  }
}

function normalizeSocialInput(
  value: string,
  parser: (url: string) => string | null,
): string {
  if (!value) return "";
  const trimmed = value.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return parser(trimmed) ?? "";
  }
  return trimmed.replace(/^@/, "");
}
